import { getConfig } from "@borealis/image";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { ReactElement } from "react";

type EmptyType = "noSearch" | "noChildren" | "extendedEmptyInherited";

type EmptyMessageProps = {
	type: EmptyType;
};

type Item = {
	title: string;
	line1: string | ReactElement;
	line2?: string;
};

export const EmptyMessage = ({ type }: EmptyMessageProps) => {
	const emptyItems: Record<EmptyType, Item> = {
		noSearch: {
			title: t`Her var det tomt gitt!`,
			line1: t`Vi finner ingen organisasjoner som matcher dine valgte kriterier.`,
			line2: t`Vennligst prøv å søke på nytt.`,
		},
		noChildren: {
			title: t`Denne organisasjonen har ingen underselskaper som kan kobles til`,
			line1: (
				<Trans>
					Ta kontakt med <a href="mailto:jobb.finn@vend.com">jobb.finn@vend.com</a> dersom dette skal oppdateres.
				</Trans>
			),
		},
		extendedEmptyInherited: {
			title: t`Venter på oppsett fra hovedkonto`,
			line1: t`Tydelig profil må settes opp av hovedkonto før dere kan bruke den. Når det`,
			line2: t`er gjort, kan du aktivere tydelig profil her.`,
		},
	};

	return (
		<div className="flex flex-col h-[368] gap-32 items-center justify-center">
			<img alt="empty-box" src={`${getConfig().base}/emptyBox.svg`} />
			<div className="flex flex-col max-w-576 gap-8 text-center">
				<h4 className="mb-0">{emptyItems[type].title}</h4>
				<div className="text-caption">
					<p className="mb-0">{emptyItems[type].line1}</p>
					{emptyItems[type].line2 && <p className="mb-0">{emptyItems[type].line2}</p>}
				</div>
			</div>
		</div>
	);
};
